module.exports = __webpack_public_path__ + "img/sxlogo.10c0c7fb.png";